import UserVerifyEmail from '@/components/Modals/UserVerifyEmail.vue';

export default {
  components: {
    UserVerifyEmail,
  },

  data () {
    return {};
  },

  methods: {
    openUserVerifyEmailModal () {
      this.$modal.show(UserVerifyEmail, {}, {
        width: 450,
        height: 350,
      });
    }
  },

  mounted () {
    const { user } = this.$store.state.auth;
    const isCustomer = this.$store.getters['auth/isCustomer'];
    const hasRateableOrder = this.$store.state.rate_platform.rateableOrder.exist;

    if (!user.is_email_verified && isCustomer && !hasRateableOrder) {
      this.openUserVerifyEmailModal();
    }
  }
};
